module.exports = __webpack_public_path__ + "media/src/application/media/img-roiv-b1355d8c155c10c1cdb593e515fc199f.jpg";